var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "8eee7ce9-842e-4a4c-a91c-40fd87179e16",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dea6e49c-ccf5-4900-9efe-5487e7f05b9c",
    x1: 16.26,
    y1: 35.42,
    x2: 21.86,
    y2: 12.43,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ad1d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5874beb0-1e64-435a-9a56-7b68c1081d74",
    x1: 9.43,
    y1: 32.13,
    x2: 24.68,
    y2: 23.88,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24bbb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "97d8fbbf-f8ed-465a-994c-1c7be0404faf",
    x1: 27,
    y1: 18.38,
    x2: 27,
    y2: 26.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcc072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58a5b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b994c3a9-dab1-4dd3-a63d-3f8009313c42",
    x1: 12.37,
    y1: 8.76,
    x2: 24.42,
    y2: 21.03,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#712b8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea1d27"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124,40H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H124a4,4,0,0,1,4,4V36A4,4,0,0,1,124,40Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,19.6V9.1a1.1,1.1,0,0,1,1-1.1,1.49,1.49,0,0,1,1,.3L31.1,18.9a.83.83,0,0,1,0,1.6L11.8,31.1a2,2,0,0,1-1,.3,1.1,1.1,0,0,1-1-1.1Z",
    style: {
      fill: "url(#dea6e49c-ccf5-4900-9efe-5487e7f05b9c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,19.7,10.6,8h.2a1.49,1.49,0,0,1,1,.3L26,16.1Z",
    style: {
      fill: "url(#5874beb0-1e64-435a-9a56-7b68c1081d74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9,23.2l-3.6-3.6L26,15.9l5.1,2.8a.83.83,0,0,1,0,1.6Z",
    style: {
      fill: "url(#97d8fbbf-f8ed-465a-994c-1c7be0404faf)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,31.2,22.3,19.6l3.6,3.6L11.8,30.9a1.61,1.61,0,0,1-1.1.3Q10.85,31.2,10.7,31.2Z",
    style: {
      fill: "url(#b994c3a9-dab1-4dd3-a63d-3f8009313c42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,33.9A4.79,4.79,0,0,1,70,32.4l1.6-.7a9.22,9.22,0,0,0,.5.8,2.47,2.47,0,0,0,1.6.8,2.29,2.29,0,0,0,1.7-.8,3.1,3.1,0,0,0,.5-1.7v-.6c-1.2,1.5-3.7,1.3-5.1-.3a4.43,4.43,0,0,1,0-5.9c1.5-1.5,3.7-1.7,5-.3V23h1.7v7.5a4.33,4.33,0,0,1-1.6,3.7,3.69,3.69,0,0,1-2.3.7,4.59,4.59,0,0,1-2.5-1Zm41.9.4,1.7-4-3-6.9h1.7l2.1,4.9,2.1-4.9h1.7l-4.6,10.9H113Zm-8.1-3.8a2.64,2.64,0,0,1-.7-1.9,2.27,2.27,0,0,1,.6-1.6,3.86,3.86,0,0,1,2.8-1,3.42,3.42,0,0,1,1.8.4,1.7,1.7,0,0,0-1.8-1.7,1.85,1.85,0,0,0-1.7,1.1l-1.5-.6a3.18,3.18,0,0,1,3.1-2,3.39,3.39,0,0,1,2.6,1,3.69,3.69,0,0,1,.8,2.6V31h-1.7v-.7a3.11,3.11,0,0,1-.9.7,3.19,3.19,0,0,1-1.4.3,3.86,3.86,0,0,1-2-.8ZM51.6,26.9a4.15,4.15,0,0,1,4.2-4.2A4.22,4.22,0,0,1,60,26.9a4.2,4.2,0,1,1-8.4,0Zm9,0a4.15,4.15,0,0,1,4.2-4.2A4.22,4.22,0,0,1,69,26.9a4.15,4.15,0,0,1-4.2,4.2A4.22,4.22,0,0,1,60.6,26.9ZM40.3,29.1a6.58,6.58,0,0,1,.1-9.2A6.35,6.35,0,0,1,45,18a6.2,6.2,0,0,1,4.4,1.8l-1.2,1.3a4.47,4.47,0,0,0-6.4.1,4.83,4.83,0,0,0,0,6.7,4.53,4.53,0,0,0,6.6.1,3.6,3.6,0,0,0,.9-2.2H45.1V24H51a6.15,6.15,0,0,1,.1,1.4,5.76,5.76,0,0,1-1.6,4,6.13,6.13,0,0,1-4.3,1.7,7.43,7.43,0,0,1-4.9-2Zm42.3.7a4.56,4.56,0,0,1,0-6,3.64,3.64,0,0,1,5.4,0,5.93,5.93,0,0,1,1.1,1.9L83.6,28a2.13,2.13,0,0,0,2,1.3,2.26,2.26,0,0,0,2.1-1.2l1.5,1a2.65,2.65,0,0,0-.5.6A4.38,4.38,0,0,1,82.6,29.8ZM93,31V19.9h3.6a3.59,3.59,0,0,1,3.8,3.3A3.35,3.35,0,0,1,97,26.5H94.8v4.4H93Zm8.4,0V19.9h1.7V31Zm-22.6-.2V18.4h1.8V30.8Zm30.5-3.1a2.73,2.73,0,0,0-1.6-.4c-1.2,0-1.9.6-1.9,1.3a1.26,1.26,0,0,0,1.4,1.1A2.09,2.09,0,0,0,109.3,27.7Zm-51.2-.8a2.31,2.31,0,1,0-4.6,0,2.37,2.37,0,0,0,2.3,2.5A2.43,2.43,0,0,0,58.1,26.9Zm9,0a2.31,2.31,0,1,0-4.6,0,2.31,2.31,0,1,0,4.6,0Zm8.9.7a.37.37,0,0,1,.1-.3v-.9c0-.1-.1-.3-.1-.4a2.32,2.32,0,0,0-2.1-1.7,2.43,2.43,0,0,0-2.2,2.5A2.38,2.38,0,0,0,74,29.3c.8.1,1.6-.6,2-1.7Zm7.3-.9L87,25.1a1.67,1.67,0,0,0-1.5-.9A2.42,2.42,0,0,0,83.3,26.7Zm15.3-3.4a1.74,1.74,0,0,0-1.9-1.7h-2v3.5h2.1A1.79,1.79,0,0,0,98.6,23.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,32.3h-.1v-.1h0v.1Zm0,0Zm0,0v0Zm0-.1v0Zm0,.1v0Zm0,0Zm0,0Zm.1,0Zm0,0Zm0-.1v0Zm0,.1v0Zm0,0Zm0-.1Zm0,.1Zm.1,0Zm0-.1h0c0,.1-.1.1,0,0Zm0,.1v0Zm0,0Zm.1-.1h0v0Zm0,.1v0Zm0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,10.1a2.78,2.78,0,0,1,2.9-2.9,2.66,2.66,0,0,1,2.3,1.2l-.8.5a1.81,1.81,0,0,0-1.5-.7,1.87,1.87,0,0,0-1.9,2,1.87,1.87,0,0,0,1.9,2,2,2,0,0,0,1.3-.5v-.9H41.5V9.9h2.7V12a2.93,2.93,0,0,1-2.3,1A2.86,2.86,0,0,1,38.9,10.1Zm6.5,2.8V7.3h3.8v.9H46.3V9.6h2.8v.9H46.3v1.6h2.9V13Zm6.6,0V8.2H50.3V7.3h4.4v.9H53v4.7Zm6.1,0V7.3h1v5.6Zm3.7,0V8.2H60.1V7.3h4.4v.9H62.8v4.7Zm5.9-2.8a2.9,2.9,0,0,1,5.8,0A2.78,2.78,0,0,1,70.6,13a2.84,2.84,0,0,1-2.9-2.9Zm4.7,0a1.81,1.81,0,0,0-1.9-2,1.92,1.92,0,0,0-1.9,2,1.81,1.81,0,0,0,1.9,2A1.86,1.86,0,0,0,72.4,10.1Zm6.1,2.8-2.9-4v4h-1V7.3h1l2.9,3.9V7.3h1v5.6Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.45c8dd1f52a43fceab50013048f9fb1e.svg";
export { ForwardRef as ReactComponent };